import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import { names, type } from '@const/learnRecord'
// 天
const Index = (props: any) => {
  const { classes, learnList, limitNumber }: any = props
  const timerDay = (n: any) =>
    moment(n.behaviorDatetime || 0).format('YYYY.MM.DD')
  // 时间
  const timerSecond = (times: number) => moment(times).format('HH:mm')

  // 按照天->数据 存储
  const transfor = (list: any) => _.groupBy(list, timerDay)

  // 一天的某一条足迹
  const liValue = (list: any) => {
    const result = list.map((item: any, index: number) => {
      const iconSrc = type.filter((val: any) => val.id === item.type)[0]
      const listValue = (
        <li key={index} title={names(item)}>
          <img src={iconSrc.icon} className={classes.icon} />
          <span className={classes.timeSecond}>
            {timerSecond(item.behaviorDatetime || 0)}
          </span>
          <span className={classes.recordName}>{names(item)}</span>
        </li>
      )
      return listValue
    })
    return result
  }
  // 展示 列表
  const display = (list: any) => {
    let i = 0
    let filterList = list.filter(
      (item: any) =>
        item.type > 0 &&
        item.type < 12 &&
        item.actionType > 0 &&
        item.actionType < 15
    )
    if (!!limitNumber) {
      filterList =
        filterList.length > limitNumber
          ? filterList.splice(0, limitNumber)
          : filterList
    }
    const listData: any = transfor(filterList)
    const listContent = _.map(listData, (value: any, key: string) => {
      const result = (
        <div key={i++} className={classes.oneDay}>
          <span className={classes.redDot} />
          <span className={classes.ymd}>{key}</span>
          <ul className={classes.listUl}>{liValue(value)}</ul>
        </div>
      )
      return result
    })

    return listContent || ''
  }

  return <div className={classes.box}>{display(learnList)}</div>
}
export default Index
